import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  divider: {
    marginTop: theme.spacing(7),
    borderBottom: [1, 'dotted', theme.palette.colors.border],
  },
  text: {
    fontSize: 24,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/AffordabilityCalculator/components/DesktopCalculationsResult/useStyles.js